<template>
    <div class="fixed-bottom-bar">
        <div class="fixed-bottom-bar-item" v-for="(item,index) of menuTab" :key="index" @click.stop="handleClickBarItem(index)" :class="{'active':item.type == activeType }">
            <span class="item-icon iconfont" v-html="item.iconUnicode"></span>
            <!-- <span class="iconfont">
                </span> -->
            <span class="item-title">
                {{ item.name }}
            </span>
        </div>
    </div>
</template>
<script>
    import { getCurrIndexByURL } from "@/assets/scripts/getNavIndex";
    export default {
        name: 'btmBar',
        data() {
            return {
                menuTab: [{
                    iconUnicode: "&#xe642;",
                    name: "首页",
                    link: "/",
                    isActive: false,
                    type: 0
                }, {
                    iconUnicode: "&#xe648;",
                    name: "动态",
                    link: "/sns/list",
                    isActive: false,
                    type: 4
                }, {
                    iconUnicode: "&#xe643;",
                    name: "科创库",
                    link: "/mall/talents",
                    isActive: false,
                    type: 3
                }, {
                    iconUnicode: "&#xe63e;",
                    name: "微视",
                    link: "/video/index",
                    isActive: false,
                    type: 5
                }, {
                    iconUnicode: "&#xe63f;",
                    name: "我的",
                    link: "/ucenter",
                    isActive: false,
                    type: 9
                }],
                activeType: 0
            }
        },
        watch:{
            '$route':'getPath'
        },
        created(){
            let { path } = this.$route;
            let { token } = this.$store.getters;
            
            // 如果没有登录。就不显示这个导航
            if(!token || window.sma.isApp.innovationChina) return false;
            this.goPath(path, getCurrIndexByURL(path));
        },
        methods: {
            getPath(){
                let { sidebar:{currNavIndex} } = this.$store.getters;
                
                // 每次发生了路由的重置之后再调用这里去设置当前选中的菜单项
                this.activeType = currNavIndex;
            },
            goPath(path, type) {
                this.$router.push({ 'path': path });
                if (type >= 0) {
                    this.$store.dispatch("app/changeNavIndex", type);
                }
                this.activeType = type;
                
            },
            // 点击菜单
            handleClickBarItem(index) {
                let { link, type } = this.menuTab[index];

                this.goPath(link, type, index);
            }
        }
    };

</script>
<style lang="scss" scoped>
@keyframes skewAni{
    0%{
        transform: scale(0);
    }
    50%{
        transform: scale(1.1);
    }
    100%{
        transform: scale(1);
    }
}
.fixed-bottom-bar {
    z-index: 9999;
    width: 100%;
    height: 100px;
    background-color: #fff;
    border-top: 1px solid #E5E5E5;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: fixed;
    left: 0;
    width: 100%;
    bottom: 0;

    &-item {
        flex: 1 0 20%;
        text-align: center;
        color: #333;
        font-size: 20px;
        line-height: 1;

        .item-icon {
            display: block;
            font-size: 32px;
            height:36px;
            margin-bottom: 3px;
        }

        &.active .item-icon {
            color: #CF001F;
            animation:skewAni 0.4s ease-in-out;
        }
    }
}

</style>
